export default {
  props: {
    btnText: {
      type: String,
      default: 'ok'
    }
  }
}
